"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeetingLocation = void 0;
var MeetingLocation;
(function (MeetingLocation) {
    MeetingLocation["Online"] = "online";
    MeetingLocation["InPerson"] = "in_person";
})(MeetingLocation = exports.MeetingLocation || (exports.MeetingLocation = {}));
